import { stringify as stringifyQuery } from 'querystring';

import { Route } from '@routes';

export type RouteLink = {
  to?: string;
  as?: string;
  href: string;
};

export const link = (route: Route, params = {}, query = {}) => {
  const [, page, toPath] = route;

  // combine query & params and clean from undefined values
  const mergedQuery: Record<string, any> = { ...params, ...query };
  Object.entries(mergedQuery).forEach(([key, value]) => {
    if (typeof value === 'undefined') delete mergedQuery[key];
  });

  // construct href and asPath
  const href = `${page}?${stringifyQuery(mergedQuery)}`;
  let asPath = toPath(mergedQuery);
  if (Object.keys(query).length) asPath += `?${stringifyQuery(query)}`;

  return { href, as: asPath } as RouteLink;
};
